import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "./Navbar";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/products", label: "Our Products" },
  { to: "/services", label: "Our Services" },
  { to: "/contact", label: "Contact Us" },
];

const serviceLinks = [
  "Payment Gateway",
  "POS Software & Hardware",
  "Value-Added Services",
  "Compliance & Training",
  "Bulk Buying Partnerships",
];

export const Footer = () => (
  <footer data-testid="site-footer" className="grain relative overflow-hidden bg-das-ink text-white">
    <div className="mx-auto max-w-7xl px-6 pb-10 pt-20 md:px-12">
      <div className="flex flex-col gap-10 border-b border-white/10 pb-14 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <Logo light />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
            Powering faster payments, smarter control, and seamless digital growth for small and
            medium businesses across South Africa and Botswana.
          </p>
        </div>
        <Link
          to="/consultation"
          data-testid="footer-book-consultation-button"
          className="group inline-flex w-fit items-center gap-2 rounded-full bg-das-violet px-7 py-4 font-display text-sm font-semibold text-white transition-colors duration-300 hover:bg-das-purple"
        >
          Book a Consultation
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>

      <div className="grid gap-12 py-14 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Explore</p>
          <ul className="mt-5 space-y-3">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm font-medium text-white/70 transition-colors hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Services</p>
          <ul className="mt-5 space-y-3">
            {serviceLinks.map((s) => (
              <li key={s}>
                <Link
                  to="/services"
                  className="text-sm font-medium text-white/70 transition-colors hover:text-white"
                >
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Contact</p>
          <ul className="mt-5 space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-das-violet" />
              Based in South Africa
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 shrink-0 text-das-violet" />
              hello@dynamicappsolutions.co.za
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 shrink-0 text-das-violet" />
              +27 64 891 0028 (Donavan)
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Markets</p>
          <p className="mt-5 text-sm leading-relaxed text-white/70">
            Serving retail, e-commerce, tourism and SMMEs across Gauteng — with Botswana as an
            additional market.
          </p>
          <p className="mt-4 inline-block rounded-full border border-das-violet/40 bg-das-violet/15 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-das-purple">
            100% Black-Owned
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
        <p className="text-xs text-white/40">
          © {new Date().getFullYear()} Dynamic App Solutions (DAS). All rights reserved.
        </p>
        <p className="text-xs uppercase tracking-[0.2em] text-white/40">
          For the new generation of business
        </p>
      </div>
    </div>
  </footer>
);
